import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { ACCOUNT_PATH } from '../../constants';
import { ModuleRole } from '../domain/module-role';
import { AppSelector } from '../store';

export const roleGuard =
	(): CanActivateFn => async (activatedRoute: ActivatedRouteSnapshot) => {
		const accountSelector = inject(AppSelector);
		const router = inject(Router);

		const { orgId } = activatedRoute.params ?? -1;
		const orgIdParam = +orgId;

		const requiredRoles: Array<ModuleRole> = activatedRoute.data['roles'] || [];

		const connectedUser = await firstValueFrom(
			accountSelector.getCurrentUser$(),
		);

		const rolesInOrganization = connectedUser.accounts.get(orgIdParam);
		const userHasAtLeastOneRole =
			connectedUser &&
			rolesInOrganization &&
			requiredRoles.some((role) => rolesInOrganization.includes(role));
		if (userHasAtLeastOneRole) {
			return true;
		} else {
			return router.parseUrl(ACCOUNT_PATH);
		}
	};
